import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
//import Pagination from "./Pagination";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import Repo from "../Utility/Repo";
import ModalComponent from "./ModalComponent";
import { TokenContext } from "./TokenContext";

const UserSubscriptionsComponent = ({
  user,
  userSubscriptionsTemp,
  userSubscriptions,
  setUserSubscriptions,
}) => {
  const apiToken = useContext(TokenContext);
  const [isOpenUnsubscribe, toggleModalUnsubscribe] = useState(false);
  const [id, setId] = useState(null);
  const getStatusComponent = (state) => {
    switch (state) {
      case "VALIDATED":
        return (
          <div className="col-12 mt-2">
            <StatusIcon
              icon="it-check-circle"
              color="success"
              text="Richiesta accettata"
            />
          </div>
        );
      case "REFUSED":
        return (
          <div className="col-12 mt-2">
            <StatusIcon
              icon="it-close-circle"
              color="danger"
              text="Richiesta rifiutata"
            />
          </div>
        );
      case "SUSPENDED":
        return (
          <div className="col-12 mt-2">
            <StatusIcon
              icon="it-close-circle"
              color="dark"
              text="Richiesta sospesa"
            />
          </div>
        );
      case "ADDED":
        return (
          <div className="col-12 mt-2">
            <StatusIcon
              icon="it-warning-circle"
              color="warning"
              text="Richiesta inviata"
            />
          </div>
        );
      case "PAGAMENTO":
        return (
          <div className="col-12 mt-2">
            <StatusIcon
              icon="it-warning-circle"
              color="warning"
              text="Richiesta con pagamento"
            />
          </div>
        );
      case "LOADED":
        return (
          <div className="col-12 mt-2">
            <StatusIcon
              icon="it-check-circle"
              color="success"
              text="Richiesta inviata"
            />
          </div>
        );

      default:
        return (
          <div className="col-12 mt-2">
            <strong className="text text-dark">Non gestito {state}</strong>
          </div>
        );
    }
  };

  const unsubscribeUser = () => {
    Repo.postUnsubscribeUser(apiToken, id)
      .then(() => {
        window.location.reload();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const StatusIcon = ({ icon, color, text }) => (
    <>
      <svg className={`icon icon-${color} mr-2 mb-1`}>
        <use xlinkHref={`${iconSprite}#${icon}`} />
      </svg>
      <b className={`text-${color}`}>{text.toUpperCase()}</b>
    </>
  );

  return (
    <div className="col-lg-12 mt-3">
      <div className="card-wrapper card-space">
        <div className="card card-bg no-after card-big roundedCustom">
          <div className="card-body">
            <div className="row my-2">
              <div className="col-lg-9">
                <h5>
                  <b>Iscrizioni</b>{" "}
                  <i>
                    {user && user.firstName
                      ? ` ${user.lastName} ${user.firstName}`
                      : ""}
                  </i>
                </h5>
              </div>
              {userSubscriptionsTemp && userSubscriptionsTemp.length > 0 ? (
                <>
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th scope="col">Titolo intervento</th>
                        <th scope="col">N.Protocollo</th>
                        <th scope="col">Data iscrizione</th>

                        <th scope="col">Stato iscrizione</th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {userSubscriptions &&
                        userSubscriptions.length > 0 &&
                        userSubscriptions.map((x, index) => (
                          <>
                            <tr key={index}>
                              <td scope="row" className="border-bottom-0">
                                {x.announcement.service.name} -{" "}
                                {x.announcement.name}
                              </td>
                              <td className="text-center border-bottom-0">
                                {x.nProtocollo ? x.nProtocollo : "-"}
                              </td>
                              <td className="border-bottom-0">
                                {x.dataIscrizione}
                              </td>

                              <td className="border-bottom-0">
                                {getStatusComponent(x.state)}
                              </td>
                              <td
                                className="text-right border-bottom-0"
                                style={{ width: "120px" }}
                              >
                                <Link
                                  to={`/lista_utenti/cartella_sociale/dettagli_iscrizione?id=${x.id}`}
                                >
                                  <button
                                    className="btn btn-outline-primary p-1"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Dettaglio iscrizione"
                                  >
                                    <svg className="icon icon-primary">
                                      <use href={`${iconSprite}#it-user`} />
                                    </svg>
                                  </button>
                                </Link>
                                <button
                                  className="btn btn-outline-danger p-1 ml-1"
                                  type="button"
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="Eliminazione iscrizione"
                                  onClick={() => {
                                    toggleModalUnsubscribe(!isOpenUnsubscribe);
                                    setId(x.id);
                                  }}
                                >
                                  <svg className="icon icon-danger">
                                    <use href={`${iconSprite}#it-delete`} />
                                  </svg>
                                </button>
                              </td>
                            </tr>
                            <tr>
                              <td colSpan={5} className="border-top-0 p-0">
                                {x.descrizioneIstanze && (
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html: x.descrizioneIstanze.replaceAll(
                                        "<br>",
                                        " ",
                                      ),
                                    }}
                                  ></span>
                                )}
                              </td>
                            </tr>
                          </>
                        ))}
                    </tbody>
                  </table>
                  {/**userSubscriptionsTemp && (
                    <Pagination
                      items={userSubscriptionsTemp}
                      setCurrentItems={setUserSubscriptions}
                      itemsPerPage={3}
                    ></Pagination>
                  )*/}
                </>
              ) : (
                <div className="mt-2 p-1">
                  L'utente non è iscritto a nessun intervento
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <ModalComponent
        labelledBy="modalConfirm"
        isOpen={isOpenUnsubscribe}
        toggleModal={() => toggleModalUnsubscribe(!isOpenUnsubscribe)}
        header="Eliminazione iscrizione utente"
        body="Confermi di voler eliminare l'iscrizione dell'utente selezionato?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => unsubscribeUser()}
      ></ModalComponent>
    </div>
  );
};

export default UserSubscriptionsComponent;
